import React, { useState } from "react";
import { Button, Checkbox, Flex, Form, message } from "antd";

import "./content.scss";
import { useNavigate, useSearchParams } from "react-router-dom";

import UserInput from "./UserInput";
import publink from "../../assets/svg/publink.svg";
import { useTranslation } from "react-i18next";
import useLogin from "../../hooks/useLogin";
import { IS_MOBILE } from "@/utils/tool";
import sentry4Action from "@/utils/sentry";
type FieldType = {
  email: string;
  password: string;
  verify_code: string;
};

interface ILoginContentProps {
  type: "login" | "modal";
  submitAction?: () => void;
}

const LoginContent: React.FC<ILoginContentProps> = ({ type, submitAction }) => {
  const { t } = useTranslation();
  const [protocol, setProtocol] = useState(false);
  const [form] = Form.useForm();
  const [searchParams] = useSearchParams();
  const redirect = searchParams.get("goto");
  const { tologin } = useLogin({ form });
  const [messageApi, contextHolder] = message.useMessage();
  const navigate = useNavigate();

  /**
   * 协议选中
   * @param e
   */
  const check = (e) => {
    setProtocol(!protocol);
  };

  const confirm = async () => {
    sentry4Action("登陆", {});
    try {
      const res = await form.validateFields();
      if (!protocol) {
        messageApi.info(t("请勾选“我已阅读 PubLink 使用协议”"));
        return;
      }
      const { isSuccess, msg } = await tologin();
      if (!isSuccess) {
        messageApi.error(msg);
        return;
      }
      if (type === "login") {
        if (redirect) {
          navigate(decodeURIComponent(redirect));
        } else {
          navigate(`/personal`);
        }
      } else {
        submitAction();
      }
    } catch (error) {}
  };
  return (
    <>
      {contextHolder}
      <div className="content-box">
        <img className="publink" src={publink} alt="" />
        <UserInput form={form} showLable={false}></UserInput>
        <Button
          type="primary"
          className="loginBtn"
          onClick={confirm}
          style={type === "modal" && IS_MOBILE ? { minWidth: "auto" } : {}}
        >
          {t("登录")}
        </Button>
        <Flex align="baseline" gap={8} justify="center">
          <Checkbox
            id="protocol"
            className="protocol"
            checked={protocol}
            onChange={check}
            style={{
              marginTop: "8px",
            }}
          ></Checkbox>
          <label htmlFor="protocol" className="protocol-label">
            <span> {t("我已阅读并同意 PubLink")} </span>
            <a className="light" href="agreement/use.html" target="_blank">
              {t("使用协议")}
            </a>
            <span> {t("和")} </span>
            <a className="light" href="agreement/privacy.html" target="_blank">
              {t("隐私协议")}
            </a>
          </label>
        </Flex>
      </div>
    </>
  );
};

export default LoginContent;
